import styled from 'styled-components';

export const Content = styled.div<{ invisible?: boolean }>`
  opacity: ${(props) => (props.invisible ? '0' : '1')};
`;

export const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacers['2M']};
`;
